













import { Component, Prop, Emit, Vue } from 'vue-property-decorator'
import appHeader from './components/Header.vue'
import slideMenu from './components/SlideMenu.vue'
@Component({
	components: {
		appHeader,
		slideMenu
	}
})
export default class AppIndex extends Vue {
	private onMenuClick (item: string): void {
		this.$router.push(item)
	}
}
